import 'angular';

angular.module('filters.addTrailingSpace', [])
  .filter('addTrailingSpace', function () {
    return function(input) {
      if (input) {
        return input + ' ';
      }
    };
  });
